<script>
    /* Executable code section of the program */
    //Tools importation
    import { alertMessagge,confirmResponse,isConfirmModalOn,confirmDeleteCustomTable } from "../../apis/storage";
  
    //Auxiliary varibles
    export let callbackFunction
  
    //Function to undisplay alert
    const undisplayAlert = () => {
      $isConfirmModalOn = false;
    };
    //Function to confirm actions
    export const confirmResponseFunction = () =>{
      $confirmResponse = true
      $isConfirmModalOn = false;
      callbackFunction()
    }
  
    /* End of the section */
  </script>
  
  <section class="principalContainer">
    <div class="alertContainer">
      <div class="headerAlertContent">
        <h4>Warning Alert</h4>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          fill="currentColor"
          class="bi bi-x-lg icon"
          viewBox="0 0 16 16"
          on:click={undisplayAlert}
          on:keypress={undisplayAlert}
        >
          <path
            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
          />
        </svg>
      </div>
      <div class="bodyAlertContainer">
        <p>{$alertMessagge}</p>
      </div>
      <div class="footerAlertContainer">
        <button class="actionButton"
        on:click={undisplayAlert}>Close</button>
        {#if $alertMessagge === "Are you sure you want to add each of the following data?"}
        <button class="actionButton createBtn"
        on:click={confirmResponseFunction}>Create Attendees</button>
          {:else}
          <button class="actionButton deleteBtn"
          on:click={confirmResponseFunction}>Delete</button>
        {/if}
      </div>
    </div>
  </section>
  
  <!-- End of the section -->
  <style>
    /* Section to place the code styles */
    /* Principal Container */
    .principalContainer {
      position: fixed;
      top: 0;
      left: 0;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 100dvh;
      z-index: 888;
      padding: 60px;
      background-color: rgba(0, 0, 0, 0.164);
    }
    /* Container */
    .alertContainer {
      background-color: white;
      width: 30%;
      height: auto;
      max-height: 30dvh;
      border-radius: 12px;
    }
    /* Header content */
    .headerAlertContent {
      display: flex;
      height: 30%;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid gray;
    }
    .icon:hover{
      color: red;
      cursor: pointer;
    }
    /* Body content */
    .bodyAlertContainer {
      padding: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40%;
      text-align: center;
    }
    /* Footer content */
    .footerAlertContainer {
      display: flex;
      width: 100%;
      height: 30%;
      justify-content: flex-end;
      align-items: center;
      border-top: 1px solid gray;
      padding: 15px;
    }
    .actionButton {
      width: 100px;
      height: 40px;
      border-radius: 12px;
      font-size: 14px;
      font-weight: 500;
      padding: 8px 16px;
      background-color: white;
      color: #111;
      border: 1px solid #444;
      transition: all 0.3s ease-in-out;
      margin: 0 10px;
    }
    .deleteBtn{
      width: 100px;
      background-color: #ed2824;
      color: white;
    }
    .createBtn{
      width: 150px;
      background-color: #ed2824;
      color: white;
    }
  
    /* /////////Tablets///////// */
    @media (min-width: 700px) and (max-width: 1100px) {
    /* Container */
    .alertContainer {
      background-color: white;
      width: 60%;
      height: auto;
      max-height: 30dvh;
      border-radius: 12px;
    }
    }
    /* /////////Cellphones ///////// */
    @media (max-width: 700px) {
      .principalContainer {
      padding: 30px;
    }
    /* Container */
    .alertContainer {
      background-color: white;
      width: 100%;
      height: auto;
      max-height: 30dvh;
      border-radius: 12px;
    }
    }
    /* End of the section */
  </style>
  